import { AppManifest, parse as parseManifest } from './app-manifest';

interface AppManifestV1 extends AppManifest {
  /** arquivo javascript principal da aplicação que expõe as funções mount e unmount no objeto window.lifecycle */
  entrypoint?: string;
  /** Arquivos javascript de dependencia que devem ser carregados antes do entrypoint */
  assets?: string[];
}

const parse = (json: AppManifestV1): AppManifestV1 => {
  return parseManifest(json);
};

export { AppManifestV1, parse };
